<div class="filter-wrapper" [ngClass]="{ mobile: rwdService.isSmallDevice }">
  <span *ngIf="!(hideLabelWhenSelected && hasSelection)" class="filter-label">{{ label }}</span>
  <mat-form-field class="hide-underline {{ longerLabels ? 'field-long' : 'field-short' }}">
    <mat-select [(value)]="currentOption" (selectionChange)="onOptionChange()">
      <ng-container *ngFor="let option of options">
        <mat-option [value]="option.value"> {{ option.title }}</mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
</div>
